import { useMemo } from 'react';
import { createContext } from '../../../../../../hooks/createContext';
import { PagedRequestSortOptions } from '../../../../../../api/generated/data-contracts';

type SortContext = {
    sort: PagedRequestSortOptions | null;
    setSort: React.Dispatch<React.SetStateAction<PagedRequestSortOptions | null>>;
};

const [useCtx, Provider] = createContext<SortContext>();

// eslint-disable-next-line react-refresh/only-export-components
export const useSortContext = useCtx;

export const SortContextProvider = ({
    children,
    setSort,
    sort,
}: {
    children: React.ReactNode;
    sort: PagedRequestSortOptions | null;
    setSort: React.Dispatch<React.SetStateAction<PagedRequestSortOptions | null>>;
}) => {
    const context = useMemo(() => {
        return {
            sort,
            setSort,
        };
    }, [setSort, sort]);
    return <Provider value={context}>{children}</Provider>;
};
